<template>
    <div>
        <Bar
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
            ref="bar"
        />
       
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip,  BarElement, CategoryScale, LinearScale, Legend)
ChartJS.register(ChartDataLabels);

export default {
    props: ['valueInput',  'chartDataInput',],
    components: { Bar },
    model: {
        prop: 'chartData',
        event: 'valueChange'
    },
   
    computed: {
       
        chartData: {
            get: function() {
                return this.chartDataInput
            },
            set: function(value) {
                
                this.$emit('valueChange', value)
            }
        },
    },
    data(){
        return{
            dateRange: ['2019-09-10', '2019-09-20'],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                // indexAxis: 'y',
                scales: {
                     x: {
                        stacked: true,
                        categoryPercentage: 0.5,
                        barThickness: 6,  // number (pixels) or 'flex'
                        maxBarThickness: 8, // number (pixels)
                        ticks: {
                            // maxRotation: 90,
                            // minRotation: 90,
                            font: {
                                size: 9,
                            },
                            // callback: function(value) {
                            //     return Utils.currencyFormat(value,"")
                            // }
                        }
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            callback:(value) => {
                                
                                   
                                return value;
                            }
                        }
                    }
                },
                plugins: {
                    // responsive: true,
                    // maintainAspectRatio: false,
                    // circumference: 180,
                    legend: {
                        display:true,
                        position: 'right'
                    },
                    tooltip:{
                        callbacks:{
                            title: (context) =>{
                                return context[0].label.substring(0,20)
                            }
                        }
                    },

                    datalabels: {
                        color: '#ffffff',
                        anchor: 'center',
                        align: 'center',
                        font: {
                        weight: 'bold',
                        size: 14
                        },
                        formatter: () => ``
                    }

                    
                    

                }
            },
            chartId: 'bar-chart',
            datasetIdKey: 'label',
            width: 350,
            height: 300,
            cssClasses: '',
            styles: {
                
                
            },
            plugins: [
                ChartDataLabels
            ],
            
          

          

        }
    },
    mounted(){
    },

    methods:{
        
    }


   
}
</script>

<style lang="scss">
    .bar-horizontal{
        &-container{
            display: flex;
            flex-direction: column;
        }
    }
</style>